import React, { useState, memo } from "react";
const validAmounts = [5, 10, 25, 50, 100, 250];
const TipBarDMs = ({ displayTip, setDisplayTip, setTipAmount }) => {
  const [selected, setSelected] = useState(0);
  return (
    <div className={displayTip ? "tipBox active" : "tipBox"}>
      <div className="allTips">
        {validAmounts.map(amount => (
          <div
            className={selected === amount ? "tipItem active" : "tipItem"}
            key={`tipDM${amount}`}
            onClick={() => {
              setSelected(amount);
              setTipAmount(amount);
              setTimeout(() => setDisplayTip(false));
            }}
          >
            ${amount}
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(TipBarDMs);
